import { render, staticRenderFns } from "./singleTextProperty.vue?vue&type=template&id=5fb84ed9"
import script from "./singleTextProperty.vue?vue&type=script&lang=js"
export * from "./singleTextProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports